// extracted by mini-css-extract-plugin
export var column = "thesis-module--column--ON3S9";
export var columnLink = "thesis-module--columnLink--RACXQ";
export var divider = "thesis-module--divider--4b6jh";
export var flexThree = "thesis-module--flexThree--P+T59";
export var headerMenuSchools = "thesis-module--headerMenuSchools--xZtAm";
export var headerMenuTitle = "thesis-module--headerMenuTitle--OZMxJ";
export var notLink = "thesis-module--notLink--7kZFb";
export var schoolAnchor = "thesis-module--schoolAnchor--84rt6";